import session from "./session"

export default {
	testLogin() {
		return session.get('auth/login/')
	},

	login(username, password, login_as_username) {
		return session.post('auth/login/', {username, password, login_as_username})
	},

	logout() {
		return session.get('auth/logout/', {})
	},
}